module.exports = __webpack_public_path__ + "static/media/1.a717c115.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/images/4033/1.jpg
// module id = 672
// module chunks = 0